import { Button } from "@itandi/itandi-bb-ui/Button";
import { Panel } from "@itandi/itandi-bb-ui/Panel";
import { PanelBody } from "@itandi/itandi-bb-ui/PanelBody";
import { PanelHeader } from "@itandi/itandi-bb-ui/PanelHeader";
import { useState } from "react";
import { DefaultV2 } from "~/components/common/layouts/DefaultV2";
import { ClientSettingLayout } from "~/components/common/layouts/settings/ClientSettingLayout";
import { CompanyVendorList } from "~/components/specifics/settings/company_vendors/CompanyVendorList";
import type { CompanyVendor } from "~/models/CompanyVendor";
import type { ItandiAccount } from "~/models/ItandiAccount";
import { CompanyVendorModal } from "./CompanyVendorModal";

type Props = {
	companyVendors: CompanyVendor[];
	currentAccount: ItandiAccount;
};

export function Page({ companyVendors, currentAccount }: Props) {
	const [isModalOpen, setIsModalOpen] = useState(false);

	const handleOpenModal = () => {
		setIsModalOpen(true);
	};
	const handleCloseModal = () => {
		setIsModalOpen(false);
	};

	return (
		<DefaultV2>
			<ClientSettingLayout>
				<Panel>
					<PanelHeader
						description="並び替えの一番上にある案件依頼先が、案件追加時に初期選択されます。"
						rightArea={
							!currentAccount.company?.fromMarket || currentAccount.isAdmin ? (
								<Button onClick={handleOpenModal} variant="primary">
									追加
								</Button>
							) : null
						}
						title="案件依頼先一覧"
					/>
					<PanelBody>
						<CompanyVendorList
							companyVendors={companyVendors}
							currentAccount={currentAccount}
						/>
					</PanelBody>
				</Panel>
				{isModalOpen ? <CompanyVendorModal onClose={handleCloseModal} /> : null}
			</ClientSettingLayout>
		</DefaultV2>
	);
}
